import $ from 'jquery'
import I18n from '../i18n-settings.js.erb'

$(document).on('turbo:load', () => {
  // Show the weight of the service group picked on the first page of new
  // inspections. The selects themselves cascade through cascade-select.js.
  // ---------------------------------------------------------------------
  const selectServiceGroupCategory = $('#inspection_service_group_category')
  const selectServiceGroup = $('#inspection_service_group_id')
  const serviceGroupWeights = $('#service_group_weights').data('id-weights')

  const setInspectionServiceGroupWeight = () => {
    let inspectionServiceGroupWeight
    const serviceGroupId = selectServiceGroup.find(':selected').val()
    for (const id in serviceGroupWeights) {
      const weight = serviceGroupWeights[id]
      if (id === serviceGroupId) {
        inspectionServiceGroupWeight = weight
      }
    }
    if (inspectionServiceGroupWeight) {
      // Set disabled text field
      $('#service_group_weight_showonly').val(inspectionServiceGroupWeight)
      // Set hidden field
      return $('#inspection_service_group_weight').val(inspectionServiceGroupWeight)
    } else {
      // Reset that stuff
      $('#service_group_weight_showonly').val('')
      return $('#inspection_service_group_weight').val('')
    }
  }

  selectServiceGroupCategory.change(() => setInspectionServiceGroupWeight())
  selectServiceGroup.change(() => setInspectionServiceGroupWeight())

  // Also after page (re)load, e.g. validation fail
  setInspectionServiceGroupWeight()

  // Set points_actual for evaluation page of new Inspections
  // ---------------------------------------------------------------------

  // Global
  const selectPercentGlobal = $('a.is_global_percent')
  const selectPercent = $('#inspected_services input.slider')

  // Global
  selectPercentGlobal.click((event) => {
    event.preventDefault()
    const percent = event.target.dataset.percent
    selectPercent.each(function() {
      $(this).bootstrapSlider('setValue', percent)
      $(this).change()
      // Adapt input size for points_actual
      $(this).attr('size', $(this).val().length)
    })
  })

  // Single
  $('#inspected_services .points_actual input').each(function() {
    $(this).prop('readonly', 'readonly')
    // Adapt input size for points_actual
    $(this).attr('size', $(this).val().length)
  })

  selectPercent.change(function() {
    const percent = $(this).val()
    const pointsTarget = $(this).closest('.body').find('.points_target input').val()
    const inputPointsActual = $(this).closest('.body').find('.points_actual input')

    // Calculate points_actual
    let pointsActual = ((pointsTarget * percent) / 100)
    // Try to localize
    pointsActual = pointsActual.toLocaleString(I18n.locale).replace(/\.0$/, '')
    // pointsActual = pointsActual.toFixed(1)
    inputPointsActual.val(pointsActual)
    if (percent === '100') {
      inputPointsActual.closest('.service').removeClass('not_inspected defective')
      $(this).closest('.body').find('input[name*="not_inspected"]').val('')
    } else {
      inputPointsActual.closest('.service').addClass('defective')
      inputPointsActual.closest('.service').removeClass('not_inspected')
      $(this).closest('.body').find('input[name*="not_inspected"]').val('')
    }
    // Adapt input size for pointsActual
    inputPointsActual.attr('size', inputPointsActual.val().length)
  })

  // Handle toggle not inspected
  const disableServiceButton = $('#inspected_services .toggle-disabled button.disable_service')
  const enableServiceButton = $('#inspected_services .toggle-disabled button.enable_service')
  disableServiceButton.click(function() {
    const inputNotInspected = $(this).closest('.body').find('input[name*="not_inspected"]')
    const pointsTarget = $(this).closest('.body').find('.points_target input').val()
    const inputPointsActual = $(this).closest('.body').find('.points_actual input')
    inputNotInspected.val(true)
    inputPointsActual.val(pointsTarget)
    inputPointsActual.closest('.service').addClass('not_inspected')
    $(this).hide()
    return $(this).closest('.body').find('button.enable_service').show()
  })
  enableServiceButton.click(function() {
    const inputNotInspected = $(this).closest('.body').find('input[name*="not_inspected"]')
    const pointsTarget = $(this).closest('.body').find('.points_target input').val()
    const inputPointsActual = $(this).closest('.body').find('.points_actual input')
    inputNotInspected.val(false)
    inputPointsActual.val(pointsTarget)
    inputPointsActual.closest('.service').removeClass('not_inspected')
    $(this).closest('.body').find('button.disable_service').show()
    return $(this).hide()
  })

  // Set clockpicker for Inspection corrections
  // ---------------------------------------------------------------------

  $('.clockpicker').clockpicker({
    autoclose: 'true',
    placement: 'top',
    default: 'now',
    align: 'left',
    donetext: '✔'
  })
})
